export type ReviewType = 'seller' | 'buyer';
export type ReviewLanguage = 'en' | 'fr' | 'de' | 'it' | 'es' | 'pt' | 'pl';

type ReviewMessages = Record<ReviewLanguage, Record<ReviewType, string>>;

const reviewMessages: ReviewMessages = {
  en: {
    seller: `It was a pleasure to accompany you in the sale of your property. I'd appreciate it if you could take a moment to leave me a review by following this link:`,
    buyer: `It was a pleasure to accompany you in the purchase of your property. I'd appreciate it if you could take a moment to leave me a review by following this link:`,
  },
  fr: {
    seller: `Ce fut un plaisir de vous accompagner dans la vente de votre bien. Je vous serais reconnaissant de prendre un moment pour me laisser un avis via ce lien:`,
    buyer: `Ce fut un plaisir de vous accompagner dans l'achat de votre bien. Je vous serais reconnaissant de prendre un moment pour me laisser un avis via ce lien:`,
  },
  de: {
    seller: `Es war mir eine Freude, Sie beim Verkauf Ihrer Immobilie zu begleiten. Ich würde mich freuen, wenn Sie sich einen Moment Zeit nehmen könnten, um mir unter folgendem Link eine Bewertung zu hinterlassen:`,
    buyer: `Es war mir eine Freude, Sie beim Kauf Ihrer Immobilie zu begleiten. Ich würde mich freuen, wenn Sie sich einen Moment Zeit nehmen könnten, um mir unter folgendem Link eine Bewertung zu hinterlassen:`,
  },
  it: {
    seller: `È stato un piacere assisterLa nella vendita del Suo immobile. Le sarei grato se potesse dedicare un momento per lasciarmi una recensione tramite questo link:`,
    buyer: `È stato un piacere assisterLa nell'acquisto del Suo immobile. Le sarei grato se potesse dedicare un momento per lasciarmi una recensione tramite questo link:`,
  },
  es: {
    seller: `Ha sido un placer acompañarle en la venta de su propiedad. Le agradecería que se tomara un momento para dejarme una reseña en el siguiente enlace:`,
    buyer: `Ha sido un placer acompañarle en la compra de su propiedad. Le agradecería que se tomara un momento para dejarme una reseña en el siguiente enlace:`,
  },
  pt: {
    seller: `Foi um prazer acompanhá-lo na venda do seu imóvel. Ficaria grato se pudesse dedicar um momento para me deixar uma avaliação através deste link:`,
    buyer: `Foi um prazer acompanhá-lo na compra do seu imóvel. Ficaria grato se pudesse dedicar um momento para me deixar uma avaliação através deste link:`,
  },
  pl: {
    seller: `Mieliśmy przyjemność towarzyszyć Państwu w sprzedaży nieruchomości. Bylibyśmy wdzięczni, gdyby mogli Państwo poświęcić chwilę na wystawienie nam opinii, klikając w poniższy link:`,
    buyer: `Mieliśmy przyjemność towarzyszyć Państwu w zakupie nieruchomości. Bylibyśmy wdzięczni, gdyby mogli Państwo poświęcić chwilę na wystawienie nam opinii, klikając w poniższy link:`,
  },
};

export const getDefaultReviewMessage = (type: ReviewType, language: string) => {
  const lang = language in reviewMessages ? (language as ReviewLanguage) : 'en';
  return reviewMessages[lang][type];
};
